<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-down-circle`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M24 46c12.15 0 22-9.85 22-22S36.15 2 24 2 2 11.85 2 24s9.85 22 22 22zm0-4c-9.941 0-18-8.059-18-18S14.059 6 24 6s18 8.059 18 18-8.059 18-18 18zm-8.586-19l8 8a1 1 0 001.32.083l.094-.083 8-8a1 1 0 00.084-1.32l-.084-.094-1.414-1.414a1 1 0 00-1.32-.084l-.094.084-5.879 5.878-5.878-5.878a1 1 0 00-1.32-.084l-.095.084-1.414 1.414a1 1 0 00-.083 1.32l.083.094 8 8-8-8z"/></svg>
</template>
<script>

export default {
  name: 'IconDownCircle',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
